<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex pa-1 xs12 sm12 md12>
            <v-card>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout wrap>
                    <div class="flex md12">
                      <div v-show="codegorunum === true ">
                        <v-text-field :label="$t('Document-Code')" :color="color" v-model="Evrak.DocTypeCode"
                          :error-messages="errors.collect('name')" v-validate="'required|max:3'" data-vv-name="name"
                          required></v-text-field>
                      </div>
                      <v-text-field :label="$t('Description')" :color="color" v-model="Evrak.DocTypeName"
                        :error-messages="errors.collect('name2')" v-validate="'required|max:100'" data-vv-name="name2"
                        required>
                      </v-text-field>
                      <v-select :items="states1" :color="color" clearable="" v-model="select"
                        :error-messages="errors.collect('select')" v-validate="'required:true'" data-vv-name="select"
                        :label="$t('Debit') + ' /' + $t('Credit') "></v-select>
                      <v-select :items="states2" :color="color" clearable="" v-model="Evrak.AccountDC"
                        :label="this.$t('Turnover-Code')"></v-select>
                    </div>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">


              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Delete" color="info" slot="activator" @click="deleteevrak()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Delete') }} </span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Update" color="info" slot="activator" @click="guncelle()" flat>
                  <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Update') }}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>

            </div>
            <div v-show="k === true">

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
              </v-tooltip>

            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('Cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Document')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="evrakekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Document')}) }}   </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Document')}) }}</span>
        </v-tooltip>



      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.Evrakkod)" item>
            <td class="text-xs-left">{{ props.item.Evrakkod }}</td>
            <td class="text-xs-left">{{ props.item.Aciklama }}</td>
            <td class="text-xs-left">{{ props.item.BA }}</td>
            <td class="text-xs-left">{{ props.item.Cari }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: this.$t('Document-Code'),
            value: 'Evrakkod'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Debit') + ' /' + this.$t('Credit'),
            value: 'BA'
          },
          {
            text: this.$t('Turnover-Code'),
            value: 'Cari'
          }
        ],
        items: [],
        color: 'orange darken-4',
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        name: '',
        name2: '',
        select: '',
        Evrak: {
          DocTypeCode: '',
          DocTypeName: '',
          DeptCredit: '',
          AccountDC: '',
          CompanyCode: '',
        },
        states1: [
          'Borç', 'Alacak'
        ],
        states2: [
          'Yok', '+', '-'
        ],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        progress: false,
        dictionary: {
          custom: {
            name: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: this.$t('Maximum-3-characters')
            },
            name2: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            select: {
              required: () => this.$t('Please-select'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
        }

        this.progress = true
        this.$http.post(auth.API_URL + 'api/doctype/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.dialog = false
             this.text1 = this.$t(response.body.ResponseMessage)
            this.progress = false
          } else {
            this.dialog = false
             this.text1 = this.$t(response.body.ResponseMessage)
            this.progress = false
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Evrak Güncelle'


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          CompanyCode: credentials.SirketKodu,
          DocTypeCode: v
        }
        this.$http.post(auth.API_URL + 'api/doctype/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Evrak.DocTypeCode = response.body[0].Evrakkod
          this.Evrak.DocTypeName = response.body[0].Aciklama
          this.select = response.body[0].BA.trim()
          this.Evrak.AccountDC = response.body[0].Cari
        })
      },
      deleteevrak: deleteevrak,
      evrakekle: evrakekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
  }

  function Kaydet() {

    this.$validator.validateAll().then((result) => {

      if (result) {
        this.Evrak.DeptCredit = this.select

        if (this.Evrak.AccountDC === 'Yok') {
          this.Evrak.AccountDC = 'Y'
        }
        if (this.Evrak.DeptCredit === 'Alacak') {
          this.Evrak.DeptCredit = '1'
        } else {
          this.Evrak.DeptCredit = '0'
        }

        var params = this.Evrak
        this.$http.post(auth.API_URL + 'api/doctype/Add', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.$http.post(auth.API_URL + 'api/doctype/List', {}, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
              this.text1 = this.$t('Update-completed')
              this.snackbar = true
            }, (response) => {
              if (response.status === 0) {
                this.dialog = false
                this.text1 = 'Service Unavailable'

              } else {
                this.dialog = false
                this.text1 = 'Service Unavailable'
              }
            })

          }
        }, (response) => {
          if (response.status === 0) {
            this.dialog = false
            this.text1 = 'Service Unavailable'
          } else {
            this.dialog = false
            this.text1 = 'Service Unavailable'
          }
        })
      }
    })
  }

  function evrakekle() {
    this.dialog = true
    this.Evrak.DocTypeCode = ''
    this.Evrak.DocTypeName = ''
    this.Evrak.DeptCredit = null
    this.$validator.reset()
    this.dialog_baslik = 'Evrak Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
  }

  function beforeMount() {


  }

  function deleteevrak() {
    if (window.confirm('Referans\'ı silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.Evrak.CompanyCode = credentials.SirketKodu



      var params1 = {
        CompanyCode: credentials.SirketKodu,
      }

      var params = this.Evrak
      this.$http.post(auth.API_URL + 'api/doctype/Delete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false
            this.text1 = 'Silme işlemi tamamlandı'
            this.snackbar = true
          }, (response) => {
            if (response.status === 0) {
              this.dialog = false
               this.text1 = this.$t(response.body.ResponseMessage)
            } else {
              this.dialog = false
               this.text1 = this.$t(response.body.ResponseMessage)
            }
          })
        } else {
          this.dialog = false
           this.text1 = this.$t(response.body.ResponseMessage)
        }
      }, (response) => {
        if (response.status === 0) {
          this.dialog = false
           this.text1 = this.$t(response.body.ResponseMessage)
        } else {
          this.dialog = false
           this.text1 = this.$t(response.body.ResponseMessage)
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {

      if (result) {
        this.Evrak.DeptCredit = this.select

        if (this.Evrak.AccountDC === 'Yok') {
          this.Evrak.AccountDC = 'Y'
        }
        if (this.Evrak.DeptCredit === 'Alacak') {
          this.Evrak.DeptCredit = '1'
        } else {
          this.Evrak.DeptCredit = '0'
        }

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        this.Evrak.CompanyCode = credentials.SirketKodu



        var params1 = {
          CompanyCode: credentials.SirketKodu,
        }
        var params = this.Evrak
        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/doctype/Update', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = this.$t('Update-completed')
            this.snackbar = true
            this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>